/** Pure helpers for the realtime socket (app/realtime.tsx), unit-tested. */

/** Reconnect delay: 1s, 2s, 4s … capped at 30s, with ±20% jitter so tabs don't stampede. */
export function backoffDelay(attempt: number, random: () => number = Math.random): number {
  const base = Math.min(30_000, 1000 * 2 ** Math.max(0, Math.min(attempt, 10)));
  const jitter = 0.8 + random() * 0.4;
  return Math.round(base * jitter);
}

/** `ws(s)://host/api/v1/realtime` for the page's own origin (nginx / Vite proxy the upgrade). */
export function realtimeUrl(location: Pick<Location, 'protocol' | 'host'>): string {
  return `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/api/v1/realtime`;
}

/** Merges messages by seq (newer copy wins: edits and deletes replace), oldest first. */
export function mergeMessages<T extends { seq: number; id: string }>(
  current: readonly T[],
  incoming: readonly T[],
): T[] {
  const bySeq = new Map<number, T>();
  for (const m of current) bySeq.set(m.seq, m);
  for (const m of incoming) bySeq.set(m.seq, m);
  return [...bySeq.values()].sort((a, b) => a.seq - b.seq);
}
